import {   GET_NOTATINDAKAN_DETAIL_ADMINTOOLS, RESET_NOTATINDAKAN_DETAIL_ADMINTOOLS } from "shared/constants/ActionTypes";

const initialState = {
  detailNotaTindakan:null
};

const notatindakanAdmintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
  
      case GET_NOTATINDAKAN_DETAIL_ADMINTOOLS:
        return {
          ...state,
          detailNotaTindakan: action.payload,
        };
        default: {
          return state;
        }

        case RESET_NOTATINDAKAN_DETAIL_ADMINTOOLS:
          return initialState
  }
};

export default notatindakanAdmintoolsReducer;
